import {z} from "zod";

export const customerManageSearchFormSchema = z.object({
	recommendedDateRangeValue: z.object({
		from: z.string().nullable(),
		to: z.string().nullable()
	}),
	managerIds: z.array(z.string())
});

export type CustomerManageSearchFormType = z.infer<typeof customerManageSearchFormSchema>;

export const customerManageSearchSchema = z.object({
	recommendedDateRangeValueAtFrom: z.string().nullable(),
	recommendedDateRangeValueAtTo: z.string().nullable(),
	managerIds: z.array(z.string())
});

export type CustomerManageSearchType = z.infer<typeof customerManageSearchSchema>;